module.exports = __webpack_public_path__ + "static/media/Dining.9db336f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/Dining.png
// module id = 132
// module chunks = 0